/**
 * ChatDrawer — the slide-in side panel container for ChatDockInner. Rendered once at the
 * app root (so it overlays any page) and toggled via ChatContext. Keeps the chat out of the
 * command center until the user wants it (Joshua's "pop out to declutter" request).
 */
import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { useChat } from '../context/ChatContext';
import ChatDockInner from './ChatDock';

const ChatDrawer: React.FC = () => {
  const { theme } = useTheme();
  const { drawerOpen, closeDrawer } = useChat();

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={closeDrawer}
        style={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0,0,0,0.35)',
          opacity: drawerOpen ? 1 : 0,
          pointerEvents: drawerOpen ? 'auto' : 'none',
          transition: 'opacity 0.2s ease',
          zIndex: 400,
        }}
      />
      {/* Panel */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          width: 'min(440px, 100vw)',
          backgroundColor: theme.background,
          borderLeft: `1px solid ${theme.border}`,
          boxShadow: '-4px 0 24px rgba(0,0,0,0.18)',
          transform: drawerOpen ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.25s ease',
          zIndex: 401,
          display: 'flex',
          flexDirection: 'column',
        }}
        aria-hidden={!drawerOpen}
      >
        {/* Mount the dock only while open to avoid background fetches when closed. */}
        {drawerOpen && (
          <ChatDockInner variant="drawer" onClose={closeDrawer} onExpand={closeDrawer} />
        )}
      </div>
    </>
  );
};

export default ChatDrawer;
